import PatientDetail from "../components/PatientDetail/PatientDetail";

export default function Patient(props) {
  return (
    <div className="m-md-5">
      <PatientDetail {...props} />
    </div>
  );
}
